import type { Provider } from "@src/interfaces/provider.interface";
import { callApi } from "@src/utils/api-client";
import { getFailureTypeForHttpStatus } from "@src/utils/failure-taxonomy";
import ClientLogsService from "./client-logs.service";
import {
  buildLocalCenterProviderSearchConfig,
  type LocalCenterProviderSearchParams,
} from "./configs/local-center-provider-search.config";
import { runManagedRequest } from "./request-manager";

export type LocalCenterProviderSearchResponse =
  | { message: Provider[]; transactionID?: string }
  | { error: string };

export async function getLocalCenterProviderList(
  params: LocalCenterProviderSearchParams,
): Promise<LocalCenterProviderSearchResponse> {
  const providerGroupKey = Array.isArray(params.providerGroupId)
    ? params.providerGroupId.join(",")
    : params.providerGroupId;

  return runManagedRequest({
    key: `local-center-provider-search:${params.userUuid}:${providerGroupKey}`,
    policy: "latest-wins",
    request: async (signal) => {
      const { data, response } = await callApi(
        buildLocalCenterProviderSearchConfig(params, signal),
      );
      if (!response.ok) {
        const error = new Error(`HTTP ${response.status}: ${response.statusText}`);
        ClientLogsService.logError(
          params.userUuid,
          "local-center-provider-search.service.getLocalCenterProviderList",
          "Error fetching local-center provider list",
          error,
          {
            errorType: getFailureTypeForHttpStatus(response.status),
            dependencyName: "LocalCenterProviderSearchAPI",
            functionName: "getLocalCenterProviderList",
          },
        );
        return { error: error.message };
      }
      return data as LocalCenterProviderSearchResponse;
    },
  });
}
